import React from 'react';
import { Sun, Moon } from 'lucide-react';

const ThemeToggle = ({ isDarkMode, setIsDarkMode, className = '' }) => (
  <button
    type="button"
    onClick={() => setIsDarkMode(!isDarkMode)}
    className={`p-2.5 rounded-full bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-amber-300 hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors shadow-sm border border-slate-200/80 dark:border-slate-700 ${className}`}
    title="Temayı Değiştir"
    aria-label={isDarkMode ? 'Aydınlık moda geç' : 'Karanlık moda geç'}
  >
    {isDarkMode ? (
      <Sun size={20} strokeWidth={2.25} className="text-amber-400" />
    ) : (
      <Moon size={20} strokeWidth={2.25} className="text-slate-600" />
    )}
  </button>
);

export default ThemeToggle;
